module.exports = __webpack_public_path__ + "static/media/مناظر سويسرا الخلابة.b6d2c7e5.jpg";